// extracted by mini-css-extract-plugin
export default {"only-for-screen-reader":"jLkmTk4sri-ACLOVbqjDDPtKMK4fuX8Yb+4vZIhVKQ0="};